import { create } from 'zustand'
import axios from '../utils/axios'

interface Payment {
  id: string
  createdAt: string
  amount: number
  status: 'draft' | 'processing' | 'successful' | 'failed' | 'refunded'
  invoiceId: string | null
  stripeChargeId: string | null
  cardBrand: string | null
  cardLast4: string | null
  failureMessage: string | null
  serviceFee: number
  stripeFee: number
  netToOrganization: number
}

interface PaymentState {
  payments: Payment[]
  loading: boolean
  error: string | null
  fetchPayments: (patronageId: string) => Promise<void>
}

export const usePaymentStore = create<PaymentState>((set) => ({
  payments: [],
  loading: false,
  error: null,

  fetchPayments: async (patronageId: string) => {
    set({ loading: true, error: null })
    try {
      // Base URL already includes /api/v3; keep the path relative to avoid double-prefix.
      const response = await axios.get(`/patrons/${patronageId}/payments`)
      set({ payments: response.data.payments, loading: false })
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error)
      set({ error: message, loading: false })
    }
  }
}))
